import React from 'react';
import { CgProfile } from "react-icons/cg";
import { BiDotsVerticalRounded } from "react-icons/bi";

const LoginButton = ({ isLoggedIn, onClick, toggleModal }) => (
  <button
    onClick={isLoggedIn ? onClick : toggleModal}
    className="landingpagebutton text-white hover:text-gray-300 flex items-center space-x-2 text-xs sm:text-sm md:text-base px-4 py-2 sm:px-3 sm:py-1"
  >
    <CgProfile className="text-base sm:text-lg md:text-xl" />
    {isLoggedIn && <BiDotsVerticalRounded className="text-base sm:text-lg md:text-xl" />}
    {!isLoggedIn && <span>Sign In</span>}
  </button>
);

export default LoginButton;
